export function uniqLib<T>(array: T[]): T[] {
  return array.filter((item, index, arr) => arr.indexOf(item) === index);
}

export function uniqueByLib<T>(array: T[], iteratee: (item: T) => any): T[] {
  const newArray: T[] = [];
  const iterateValues: T[] = [];

  array.forEach((item) => {
    const value = iteratee(item);
    if (!iterateValues.includes(value)) {
      // adds item to return array
      newArray.push(item);
      // adds value to keep track of whats been added
      iterateValues.push(value);
    }
  });
  return newArray;
}
